/**
 * Created on 2017/3/20.
 */
define('controllers/myaccount/balance/order-detail.ctrl',['app', 'mainCons'], function (app, mainCons) {
    //订单详情contorller
    app.controller('OrderDetailCtrl', ['$scope', 'OpenOther', 'OpenTrade', 'OpenApp', '$stateParams', 'regionService', 'commonUtils','auiTeamAccountService',
        function ($scope, OpenOther, OpenTrade, OpenApp, $stateParams, regionService, commonUtils,auiTeamAccountService) {
            //获取订单ID
            var orderId = $stateParams.orderId;
            $scope.signParty = $stateParams.signParty;
            $scope.currencyUnit = mainCons.balanceConstant.currentUnits[$scope.signParty];
            $scope.Model.constant = {
                orderStatus: mainCons.balanceConstant.orderStatus,
                purchaseType: mainCons.balanceConstant.purchaseType,
                contractType: mainCons.balanceConstant.contractType,
                isForCpType: mainCons.balanceConstant.isForCpType
            };


            //调用接口获取订单详情
            OpenTrade.getOrderDetail({
                req: {
                    orderId: orderId
                }
            }).then(function (res) {
                if (res) {
                    $scope.orderInfo = res.orderInfo;
                    //初始化实名认证的国家列表
                    if ($scope.orderInfo && $scope.orderInfo.agentCountry) {
                        auiTeamAccountService.getRealNameCountryList().then(function (data) {
                            var countrys = data.allContrysFromInterface;
                            $scope.agentCountryObj = countrys.find(function (country) {
                                return country.country === $scope.orderInfo.agentCountry;
                            })
                        });
                    }
                    if ($scope.orderInfo.payingCredentials) {
                        var pic = $scope.orderInfo.payingCredentials.split(",");

                        if (pic[0] != "" && pic[0] != undefined) {
                            $scope.certificate1 = pic[0];
                        } else {
                            $scope.certificate1 = "";
                        }
                        if (pic[1] != "" && pic[1] != undefined) {
                            $scope.certificate2 = pic[1];
                        } else {
                            $scope.certificate2 = "";
                        }
                        if (pic[2] != "" && pic[2] != undefined) {
                            $scope.certificate3 = pic[2];
                        } else {
                            $scope.certificate3 = "";
                        }
                        commonUtils.picExtend("boximg_1", "boximg_2", "boximg_3");
                    }
                    getAppName();
                }
            });

            function getAppName() {
                if ($scope.orderInfo.appId) {
                    var contractTypeAppIdList = [];
                    contractTypeAppIdList.push($scope.orderInfo.appId);
                    OpenApp.getAppBriefList({
                        req: {
                            prodIDList: AUI.BaseJSUtil.unique(contractTypeAppIdList),
                            maxReqCount: 5000,
                            lang: 'zh_cn'
                        }
                    }).then(function (resp) {
                        if (resp && resp.resultCode == 0 && resp.appBriefList.length > 0) {
                            $scope.orderInfo.appName = resp.appBriefList[0].prodName;
                        }
                    })
                }
            }

        }]);
});

